// extracted by mini-css-extract-plugin
module.exports = {"container":"toggleSwitch_container__0DQBg","switch":"toggleSwitch_switch__W4S0Y","checkbox":"toggleSwitch_checkbox__7FVPe"};